module.exports = __webpack_public_path__ + "static/media/institutions-icon-2.1fb06785.svg";